<template>
  <div class="flex-shrink-0 w-full p-6 space-y-4 overflow-hidden lg:max-w-sm ring-1 ring-gray-200/10 bg-gradient-black-01 rounded-xl">
    <slot />
  </div>
</template>
